import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NewsCategories from './pages/NewsCategories';
import BreakingNews from './pages/BreakingNews';
import TrendingNews from './pages/TrendingNews';
import News from './pages/News';
import Advertisements from './pages/Advertisements';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<Login />} />

            {/* Redirect root to dashboard */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            {/* Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/news-categories"
              element={
                <ProtectedRoute>
                  <Layout>
                    <NewsCategories />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/breaking-news"
              element={
                <ProtectedRoute>
                  <Layout>
                    <BreakingNews />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/trending-news"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TrendingNews />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/news"
              element={
                <ProtectedRoute>
                  <Layout>
                    <News />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/advertisements"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Advertisements />
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>

          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                theme: {
                  primary: 'green',
                  secondary: 'black',
                },
              },
              error: {
                duration: 5000,
                theme: {
                  primary: 'red',
                  secondary: 'black',
                },
              },
            }}
          />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;











































// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { Toaster } from 'react-hot-toast';
// import Layout from './components/Layout';
// import Dashboard from './pages/Dashboard';
// import NewsCategories from './pages/NewsCategories';
// import BreakingNews from './pages/BreakingNews';
// import TrendingNews from './pages/TrendingNews';
// import News from './pages/News';
// import Advertisements from './pages/Advertisements';
// import './App.css';

// function App() {
//   return (
//     <Router>
//       <div className="App">
//         <Layout>
//           <Routes>
//             <Route path="/" element={<Dashboard />} />
//             <Route path="/dashboard" element={<Dashboard />} />
//             <Route path="/news-categories" element={<NewsCategories />} />
//             <Route path="/breaking-news" element={<BreakingNews />} />
//             <Route path="/trending-news" element={<TrendingNews />} />
//             <Route path="/news" element={<News />} />
//             <Route path="/advertisements" element={<Advertisements />} />
//           </Routes>
//         </Layout>
//         <Toaster 
//           position="top-right"
//           toastOptions={{
//             duration: 4000,
//             style: {
//               background: '#363636',
//               color: '#fff',
//             },
//             success: {
//               duration: 3000,
//               theme: {
//                 primary: 'green',
//                 secondary: 'black',
//               },
//             },
//             error: {
//               duration: 5000,
//               theme: {
//                 primary: 'red',
//                 secondary: 'black',
//               },
//             },
//           }}
//         />
//       </div>
//     </Router>
//   );
// }

// export default App;